import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LifeBuoy, BookOpen, MessageCircleHeart, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const HelpMenu = ({ i, where, label = "Help me with this" }) => {
  const { profile, buddy, setTutorOpen, setTutorContext } = useProfile();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  if (profile?.role !== "student" || i.source !== "school" || i.done) return null;
  if (i.status === "check") return <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#F1EFEA] text-xs text-stone-500 whitespace-nowrap" data-testid={`help-locked-${where}-${i.id}`} title="Past due: the school system may not accept it anymore"><Lock className="w-3.5 h-3.5" /> Locked at school</span>;
  const name = buddy?.name || "my Buddy";
  const lesson = async () => {
    setBusy(true);
    try { const h = (await http.post(`/school-help/${i.id}`)).data; nav(`/learn/${h.subject_id}?topic=${encodeURIComponent(h.topic)}&focus=${encodeURIComponent(h.focus)}&for=${encodeURIComponent(h.assignment)}`); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const chat = () => {
    const assignment = `${i.topic}${i.course ? ` (${i.course})` : ""}`;
    setTutorContext({ subject_id: i.subject_id, assignment, prefill: `Can you help me understand my school assignment "${assignment}"? Please help me think it through without giving me the answers.` });
    setTutorOpen(true);
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={`help-btn-${where}-${i.id}`} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#FBF3E2] border border-[#F2D49B] text-xs text-[#7A4A12] hover:bg-[#F7E6C4] whitespace-nowrap">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <LifeBuoy className="w-3.5 h-3.5" />} {label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#FDFBF7]">
        <DropdownMenuItem onSelect={lesson} data-testid={`help-lesson-${where}-${i.id}`} className="gap-2 cursor-pointer"><BookOpen className="w-4 h-4" /> Learn it with a Buddy lesson</DropdownMenuItem>
        <DropdownMenuItem onSelect={chat} data-testid={`help-chat-${where}-${i.id}`} className="gap-2 cursor-pointer"><MessageCircleHeart className="w-4 h-4" /> Talk it through with {name}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
